<style></style>
<template>
    <section>
        <compSteplist
            v-if="isQuery"
            :status="getStatus"
            :needBox="formData.needBox == 1"
        ></compSteplist>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="isQuery"
                class="margin-layout"
                :formdata="getBase"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="formbase"
                class="margin-layout"
                :formdata="getBase"
                v-model="formData"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.inbound.shipment_information', {
                    defaultValue: '发运信息',
                })
            "
            theme="primary"
            v-if="
                (getStatus > 19 && getStatus != 100) ||
                (formData.actualShipDate && getStatus == 100)
            "
        >
            <compDelivergood :value="formData"></compDelivergood>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.inbound.incomeprod_information', {
                    defaultValue: '入库产品信息',
                })
            "
            theme="primary"
        >
            <compProduct
                class="margin-layout"
                ref="productlist"
                :data="productList"
                :baseData="formData"
                :status="getStatus"
                :poBos="getPoNos"
                :proinblundList="proinblundList"
                :detailtype="fbquerytype"
                :activeid="id"
                :querytype="querytype"
                :isManage="isManage"
                @on-newdata="getchangeData"
                @on-updatelist="Onupdatelist"
                @on-updateline="getLine"
            ></compProduct>
            <vButtonGroup slot="footer" v-if="!alertbox">
                <vButton
                    v-for="item in getStatusBtns"
                    :key="item.name"
                    @click="item.run"
                    :theme="item.theme"
                    >{{ item.name }}</vButton
                >
            </vButtonGroup>
        </compWrapper>
        <compWrapper
            :title="$t('global.common.attache', { defaultValue: '附件信息' })"
            theme="info"
        >
            <compAttach
                class="margin-layout"
                ref="attachlist"
                :data="attachList"
                :status="getStatus"
                :activeid="id"
                @on-update="getDetail"
            ></compAttach>
        </compWrapper>
        <compPhotoLog v-if="type === 'query'" v-bind="photoData"></compPhotoLog>
        <!-- <compLog v-if="type==='query'" wrapper :columns="getLogColumns" :data="logList"></compLog> -->
        <compWrapper
            v-if="type === 'query'"
            :title="$t('global.log.name', { defaultValue: '操作历史' })"
            theme="gray"
        >
            <vTable
                class="margin-15"
                :columns="getLogColumns"
                :data="logList"
                border
            ></vTable>
            <div class="text-right margin-right-15" v-if="alertbox">
                <vButton
                    class="margin-left-10"
                    v-for="item in getStatusBtns"
                    :key="item.name"
                    @click="item.run"
                    :theme="item.theme"
                    >{{ item.name }}</vButton
                >
            </div>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
            @on-confirm="getDetail"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
                @on-close="closemodalprops"
            />
        </compModal>
        <compModal
            v-model="modalProps2.show"
            v-bind="modalProps2"
            @on-close="closemodalprops2"
        >
            <component
                v-if="modalProps2.component"
                :is="modalProps2.component"
                v-bind="modalProps2.props"
                v-on="modalProps2.on"
                @on-close="closemodalprops2"
            />
        </compModal>
    </section>
</template>

<script>
import {
    HttpInboundBillItem,
    HttpInboundBill,
    HttpComplateInboundBill,
    HttpUploadBill,
    HttpConfirmAtWarehouse,
    HttpAddInboundBill,
    HttpSubmitInboundBill,
    HttpCheckInboundBill,
    HttpUpdateInboundBill,
    HttpSaveAndSubmitInboundBill,
    HttpPushWareHouse,
    HttpConfirmAPost,
    HttpUpdateAndSubmitInboundBill,
    HttpRevokeAudit,
    HttpIsPackList,
    HttpUploadCompleteFile,
    HttpGetSKUEnName,
    HttpReprocessError,
    HttpIgnoreInboundError,
    HttpCheckCapacity,
    HttpUpdateInboundDate,
    HttpGetAreaList,
} from "@/service/inbound";
import { HttpGetDetailByNos } from "@/service/headlogistics";
import { HttpFindByOrgIdAndOrgWarehouseId } from "@/service/allotment";

import { mapGetters } from "vuex";
import compAttach from "./attach";
import compProduct from "./product";
import compSteplist from "./steplist";
import compDelivergood from "./delivergood";
import compChooseWarehouse from "./choosewarehouse";
import compAudit from "./audit";

import mixin from "../mixin";

export default {
    mixins: [mixin],
    props: ["activeid", "querytype", "alertbox", "managetype"],
    components: {
        compSteplist,
        compAttach,
        compProduct,
        compDelivergood,
        compChooseWarehouse,
        compAudit,
    },
    data() {
        return {
            loading: false,
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            no: this.$route.query.no,
            fbquerytype: this.$route.query.type,
            manageuse: this.$route.query.type,
            showModal: false,
            formData: {
                inventoryType: 0,
                originCountry: "China",
                areaId: null,
                businessType: [],
                orgWarehouseId: null,
            },
            productList: [], //入库计划单明细,
            attachList: [], //附件列表
            logList: [], //log,
            modalProps: {
                show: false,
                // title: '导入数据',
                // component: "",
                // props: {},
                // on: {},
            },
            modalProps2: {
                show: false,
                // title: '导入数据',
                // component: "",
                // props: {},
                // on: {},
            },
            complateFiles: [],
            billFiles: [],
            proinblundList: [],
            channelList: [],
            showOnaccount: false,
            showCapacity: false,
            showInboundVolume: true,
            isCapacity: false,
            restCapacity: "",
            totalCapacity: "",
            totalRestCapacity: "",
            photoData: {},
            completeRemark: "",
            uploadBillNo: "",
            uploadBillDate: "",
            modalSelectedData: "",
            inputKey: "orgWarehouseId",
            // 用于查看编辑展示匹配区域
            areaList: [],
        };
    },
    async created() {
        this.loading = true;
        // 添加权限
        this.perUpdate = this.handleAuth("fbb.inboundplan.update");
        this.preUploadBill = this.handleAuth("fbb.inboundorder.upload");
        this.preUpdateDate = this.handleAuth("fbb.inboundorder.updatedate");
        this.perAudit = this.handleAuth("fbb.inboundplan.check");
        this.perComplete = this.handleAuth("fbb.inboundplan.complate");
        this.perChangeWarehouse = this.handleAuth(
            "fbb.inboundplan.changeWarehouse"
        );
        // 客户端审核权限
        this.clientAudit = this.handleAuth("fbb.inboundplan.orgcheck");
        // 客户端完成权限
        this.clientComplete = this.handleAuth("fbb.inboundplan.orgcomplate");
        if (this.type != "add") {
            await this.getAreaList();
        }
        await this.getDetail();

        this.loading = false;
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getOrgList",
            "getCountryList",
            "getFilterDisabledWarehouse",
        ]),
        getStatus() {
            return this.type !== "add" && this.formData.inboundPlanOrderStatus;
        },
        getPoNos() {
            return this.formData.poNos;
        },
        getErrorStatus() {
            // console.log(this.formData);
            return this.type !== "add" && this.formData.errorStatus;
        },
        isEdit() {
            return this.type === "edit";
        },
        isQuery() {
            return this.type === "query";
        },
        isAdd() {
            return this.type === "add";
        },
        //管理端
        isManage() {
            return this.manageuse === "manage";
        },
        /**
         * 根据状态显示不同按钮
         */
        getStatusBtns() {
            const getStatus = this.getStatus;
            const getErrorStatus = this.getErrorStatus;
            // console.log(getErrorStatus);
            const btn = [
                {
                    name: this.$t("fbb.inbound.update_date", {
                        defaultValue: "更新预计入库日期",
                    }),
                    theme: "info",
                    show:
                        (getStatus == 0 ||
                            getStatus == 5 ||
                            getStatus == 8 ||
                            getStatus == 10) &&
                        this.preUpdateDate &&
                        this.isQuery,
                    run: this.updateInboundDate,
                },
                {
                    name: this.$t("fbb.inbound.show_capacity", {
                        defaultValue: "查看库容",
                    }),
                    show: this.isCapacity,
                    theme: "info",
                    run: this.capacity,
                },
                {
                    name: this.$t("fbb.inbound.save_draft", {
                        defaultValue: "保存为草稿",
                    }),
                    show:
                        this.isAdd ||
                        (this.isEdit && getStatus == 0) ||
                        (getStatus == 6 && this.isEdit),
                    theme: "primary",
                    run: this.save,
                },
                {
                    name: this.$t("fbb.inbound.submit_audit", {
                        defaultValue: "提交审核",
                    }),
                    show:
                        (this.isAdd ||
                            (this.isEdit && getStatus == 0) ||
                            getStatus == 6) &&
                        this.perUpdate,
                    theme: "error",
                    run: this.submit,
                },
                // {
                // 	name: '撤销审核',
                // 	theme: 'warning',
                // 	show: getStatus == 5 && !this.isManage && this.perUpdate,
                // 	run: this.rebackAudit
                // },
                {
                    name: this.$t("fbb.inbound.audit", {
                        defaultValue: "审核",
                    }),
                    theme: "success",
                    show:
                        getStatus == 5 &&
                        (this.isManage ? this.perAudit : this.clientAudit),
                    run: this.approve,
                },
                {
                    name: this.$t("fbb.inbound.packing", {
                        defaultValue: "装箱",
                    }),
                    theme: "warning",
                    show: getStatus == 8,
                    run: this.goBoxing,
                },
                {
                    name: this.$t("fbb.inbound.confirm_delivery", {
                        defaultValue: "确认发货",
                    }),
                    theme: "success",
                    show: getStatus == 8 || getStatus == 10,
                    run: this.confirmDeliver,
                },
                {
                    name: this.$t("fbb.inbound.port_confirm", {
                        defaultValue: "到港确认",
                    }),
                    theme: "success",
                    show:
                        (getStatus == 20 ||
                            getStatus == 25 ||
                            getStatus == 70) &&
                        !this.formData.arrivePortDate,
                    run: this.confirmAtPost,
                },
                /*  {
				name: this.$t('fbb.inbound.warehouse_confirm', { defaultValue: '到仓确认' }),
				theme: 'primary',
				show: (getStatus == 20 || getStatus == 25 || getStatus == 70) && !this.formData.actualArriveTime,
				run: this.confirmAtWarehouse
			}, */ {
                    name: this.$t("fbb.inbound.repush_warehouse", {
                        defaultValue: "重推仓库",
                    }),
                    theme: "info",
                    show: getStatus == 20,
                    run: this.pushWareHouse,
                },
                {
                    name: this.$t("fbb.headlogistics.shangchuanfapiao", {
                        defaultValue: "上传发票",
                    }),
                    theme: "primary",
                    show:
                        (getStatus == 20 ||
                            getStatus == 25 ||
                            getStatus == 70) &&
                        !this.formData.billNo &&
                        this.preUploadBill,
                    run: this.uploadBill,
                },
                {
                    name: this.$t("global.common.finish", {
                        defaultValue: "完成",
                    }),
                    theme: "success",
                    show:
                        (getStatus == 20 || getStatus == 25) &&
                        (this.isManage
                            ? this.perComplete
                            : this.clientComplete),
                    run: this.complateBill,
                },
                {
                    name: this.$t("global.common.reprocess", {
                        defaultValue: "重处理",
                    }),
                    theme: "success",
                    show: this.isAdd == false && getErrorStatus != 99999,
                    run: this.errorReprocess,
                },
                {
                    name: this.$t("global.common.ignoreError", {
                        defaultValue: "忽略异常",
                    }),
                    theme: "info",
                    show: this.isAdd == false && getErrorStatus != 99999,
                    run: this.ignoreError,
                },
                {
                    name:
                        this.alertbox == "alertbox"
                            ? this.$t("global.common.close", {
                                  defaultValue: "关闭",
                              })
                            : this.$t("global.common.return", {
                                  defaultValue: "返回",
                              }),
                    theme: "default",
                    show: true,
                    run: this.cancel,
                },
            ];

            return btn.filter((item) => item.show);
        },

        getBase() {
            return [
                {
                    label: this.$t("fbb.inbound.storage_number", {
                        defaultValue: "入库计划单号",
                    }),
                    key: "inboundPlanOrderNo",
                    query: true,
                    show: this.isEdit || this.isQuery,
                    valueText:
                        this.formData.errorStatus <= 999
                            ? this.formData.inboundPlanOrderNo +
                                  '<span class="color-error"> ' +
                                  this.findRenderLabel(
                                      this.getAbnormalType,
                                      this.formData.errorStatus
                                  ) || "--" + "</span>"
                            : this.formData.inboundPlanOrderNo,
                },
                {
                    label: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    key: "inboundPlanOrderStatus",
                    show: this.isEdit || this.isQuery,
                    options: this.getBillStatus,
                    query: true,
                },
                {
                    label: this.$t("fbb.inbound.error_status", {
                        defaultValue: "异常状态",
                    }),
                    key: "errorStatus",
                    show: false,
                },
                {
                    label:
                        this.$t("erp.channelbase.area", {
                            defaultValue: "区域",
                        }) +
                        "/" +
                        this.$t("fbb.inbound.storage_warehouse", {
                            defaultValue: "入库仓库",
                        }),
                    // key: this.isQuery ? "orgWarehouseCode" : "orgWarehouseId",
                    key: this.inputKey,
                    tag: "div",
                    render: (h) => {
                        let areaName = null;
                        if (this.formData.areaId) {
                            areaName = this.areaList.filter((item) => {
                                return item.value == this.formData.areaId;
                            })[0].label;
                        }
                        // return <div class="text-wrap">{areaName || "--"}/{this.formData.orgWarehouseCode || "--"}</div>;
                        if (this.formData.areaId) {
                            areaName = this.areaList.filter((item) => {
                                return item.value == this.formData.areaId;
                            })[0].label;
                            if (this.formData.orgWarehouseCode) {
                                return (
                                    <div class="font-bold">
                                        {areaName}/
                                        {this.formData.orgWarehouseCode}
                                    </div>
                                );
                            }
                            return <div class="font-bold">{areaName}</div>;
                        } else {
                            return (
                                <div class="font-bold">
                                    {this.formData.orgWarehouseCode}
                                </div>
                            );
                        }
                    },
                    children: (h) => {
                        return (
                            <div>
                                <vInput readonly value={this.modalSelectedData}>
                                    <Icon
                                        type="ios-search"
                                        style="font-size: 16px; margin-right: 10px; cursor: pointer;"
                                        slot="suffix"
                                        onClick={this.handleWarehouse}
                                    />
                                </vInput>
                            </div>
                        );
                    },
                    // tag: "vSelect",
                    // options: this.isQuery ? null : this.getFilterDisabledWarehouse,
                    // on: {
                    // 	'on-attach': (attach, val) => {
                    // 		if (attach.warehouseType === 4) {
                    // 			// console.log(attach,val)
                    // 			this.showOnaccount = true
                    // 			this.getChannel(val)
                    // 		} else this.showOnaccount = false
                    // 		this.formData.warehouseType = attach.warehouseType
                    // 		this.checkCapacity()
                    // 	},
                    // },
                    // props: {
                    // 	filterable: true
                    // },
                },
                {
                    label: this.$t("global.common.channel", {
                        defaultValue: "渠道",
                    }),
                    key: "sourceChannel",
                    show: this.isQuery,
                },
                {
                    label: this.$t("global.common.channel", {
                        defaultValue: "渠道",
                    }),
                    tag: "vSelect",
                    key: "sourceChannel",
                    options: this.channelList.map((item) => {
                        return {
                            value: item.accountFlag,
                            label: item.accountFlag,
                        };
                    }),
                    show: this.showOnaccount && !this.isQuery,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("global.common.line", {
                        defaultValue: "项目",
                    }),
                    tag: "vSelect",
                    key: this.isQuery ? "lineName" : "lineId",
                    options: this.isQuery
                        ? null
                        : this.getProductList.map((item) => {
                              return {
                                  value: item.value,
                                  label: item.attach.name,
                              };
                          }),
                    required: true,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("global.common.source_number", {
                        defaultValue: "来源单号",
                    }),
                    key: "sourceNo",
                    required: false,
                },
                {
                    label: this.$t("fbb.inbound.inventory_type", {
                        defaultValue: "库存类型",
                    }),
                    tag: "vSelect",
                    key: "inventoryType",
                    options: this.getInventoryType,
                },
                {
                    label: this.$t("fbb.inbound.shipper_name", {
                        defaultValue: "发货方名称",
                    }),
                    key: "shipperName",
                },
                {
                    label: this.$t("fbb.inbound.shipper_address", {
                        defaultValue: "发货方地址",
                    }),
                    key: "shipperAddress",
                },
                // {
                // 	label: this.$t('fbb.inbound.shipper_contact', { defaultValue: '发货方联系人' }),
                // 	key: "shipperContact",
                // },
                // {
                // 	label: this.$t('fbb.inbound.contact_phone', { defaultValue: '联系电话' }),
                // 	key: "shipperPhone",
                // },
                {
                    label: this.$t("fbb.inbound.origin_country", {
                        defaultValue: "原产地",
                    }),
                    tag: "vSelect",
                    key: "originCountry",
                    options: this.getCountryList.map((item) => {
                        return {
                            label: item.label,
                            value: item.attach.nameEn,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("fbb.inbound.batch_no", {
                        defaultValue: "批次号",
                    }),
                    key: "batchNumber",
                    required: false,
                },
                {
                    label: "Shipment ID",
                    key: "shipmentId",
                    required: this.showOnaccount,
                    props: {
                        placeholder: this.$t("fbb.inbound.fill_aamazon", {
                            defaultValue: "发往亚马逊的需填写",
                        }),
                    },
                },
                {
                    label: "Reference ID",
                    key: "referenceId",
                    required: false,
                    props: {
                        placeholder: this.$t("fbb.inbound.fill_aamazon", {
                            defaultValue: "发往亚马逊的需填写",
                        }),
                    },
                },
                {
                    label: this.$t("fbb.inbound.expect_arrivaldate", {
                        defaultValue: "期望到货日期",
                    }),
                    key: "expectArriveDate",
                    tag: "vDatepicker",
                    props: {
                        format: "yy-mm-dd",
                    },
                    on: {
                        "on-blur": (val) => {
                            this.checkCapacity();
                        },
                    },
                },
                {
                    label: this.$t("fbb.inbound.expect_deliverydate", {
                        defaultValue: "预计发货日期",
                    }),
                    key: "predictionShipDate",
                    tag: "vDatepicker",
                    props: {
                        format: "yy-mm-dd",
                    },
                },
                {
                    label: this.$t("fbb.inbound.business_model", {
                        defaultValue: "业务模式",
                    }),
                    key: "businessType",
                    tag: "vCheckBox",
                    // 查看时有数据才展示、添加编辑时选中区域时才展示
                    show: this.isQuery
                        ? !!this.formData.businessType[0]
                        : this.inputKey == "areaId",
                    render: (h) => {
                        // if (!this.formData.businessType[0] || !this.formData.length) return "--";
                        let text = this.formData.businessType
                            .map((value) => {
                                return this.getBusinessType.filter((item) => {
                                    return value == item.trueValue;
                                })[0].label;
                            })
                            .join(",");
                        return text;
                    },
                    // props: {
                    //     strict: false,
                    // },
                    options: this.getBusinessType,
                },
                {
                    label: this.$t("fbb.headlogistics.container_number", {
                        defaultValue: "集装箱号",
                    }),
                    tag: "Input",
                    key: "cartonNo",
                    required: false,
                    show: !this.isQuery,
                },
                {
                    label: this.$t("fbb.headlogistics.container_number", {
                        defaultValue: "集装箱号",
                    }),
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.gpCartonNo20 ||
                                    this.formData.gpCartonNo40 ||
                                    this.formData.hqCartonNo40 ||
                                    this.formData.hqCartonNo45}
                            </div>
                        );
                    },
                    show: this.isQuery,
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    tag: "vTextarea",
                    key: "remark",
                    required: false,
                },
            ];
        },
        getLogColumns() {
            return [
                {
                    title: this.$t("global.common.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "createdName",
                    // render(h, { row }) {
                    // 	return row.createdName || row.updatedName;
                    // },
                },
                {
                    title: this.$t("global.common.operate_type", {
                        defaultValue: "操作类型",
                    }),
                    key: "opAction",
                    render: (h, { row }) => {
                        // const opActionMap = this.getLogActions || {};
                        // const value = row.opAction || row.operateType;
                        return this.getLogActions[row.operateType] || "";
                    },
                },
                {
                    title: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    width: "30%",
                },
                {
                    title: this.$t("global.common.attach_file", {
                        defaultValue: "附件",
                    }),
                    key: "remark",
                    width: "30%",
                    render(h, { row }) {
                        const extraData = row.extraData;
                        return extraData
                            ? JSON.parse(extraData).map((item) => {
                                  return (
                                      <div>
                                          <a
                                              download={item.fileName}
                                              href={item.fileUrl}
                                          >
                                              {item.fileName || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    title: this.$t("global.common.operate_time", {
                        defaultValue: "操作时间",
                    }),
                    key: "createdAt",
                },
            ];
        },
        getBusinessType() {
            return [
                {
                    label: "B2B",
                    trueValue: 1,
                },
                {
                    label: "B2C",
                    trueValue: 2,
                },
                {
                    label: "待定",
                    trueValue: 3,
                },
            ];
        },
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        closemodalprops2() {
            this.$emit("on-openCloseable");
            this.modalProps2 = {};
        },
        async getAreaList() {
            await HttpGetAreaList().then(
                (res) => {
                    this.areaList = res.data.map((item) => {
                        return {
                            label: item.areaName,
                            value: item.id,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleWarehouse() {
            this.$emit("on-closeCloseable");
            this.modalProps2 = {
                show: true,
                title: "选择区域/仓库",
                width: 1200,
                component: "compChooseWarehouse",
                showFooter: false,
                on: {
                    "on-close": () => {
                        this.modalProps2.show = false;
                    },
                    // 选中仓库
                    "on-select-warehouse": (warehouseData) => {
                        this.inputKey = "orgWarehouseId";
                        this.formData.areaId = null;
                        this.formData.orgWarehouseId = warehouseData.id;
                        this.modalSelectedData = warehouseData.code;
                    },
                    // 选中区域
                    "on-select-area": (areaData) => {
                        this.inputKey = "areaId";
                        this.formData.orgWarehouseId = null;
                        this.formData.areaId = areaData.id;
                        this.modalSelectedData = areaData.areaName;
                    },
                },
            };
        },
        Onupdatelist() {
            this.getDetail();
        },
        getLine(val) {
            this.$set(this.formData, "lineId", val.lineId);
        },
        // 获取新的项目，发货信息
        getchangeData(val) {
            this.$set(this.formData, "lineId", val.lineId);
            this.$set(this.formData, "shipperName", val.shipName);
            this.$set(this.formData, "sourceNo", val.refNumber);
            this.$set(this.formData, "shipperAddress", val.shipAddress);
            // this.$set(this.formData, 'orgWarehouseId', val.orgWarehouseId)
            this.$set(
                this.formData,
                "predictionShipDate",
                val.predictionShipDate
            );
            let channelone =
                this.getFilterDisabledWarehouse.filter((json) => {
                    return json.value == this.formData.orgWarehouseId;
                })[0] || {};
            if (
                Object.keys(channelone).length !== 0 &&
                channelone.attach.warehouseType == 4
            ) {
                this.getChannel(channelone.value);
                this.showOnaccount = true;
            } else this.showOnaccount = false;
            this.$set(this.formData, "batchNumber", val.batchNumber);
        },
        // 跳转装箱
        goBoxing(obj) {
            if (obj.newWindow) {
                window.open(
                    this.$router.resolve({
                        name: this.isManage
                            ? "inboundBillmanageBoxing"
                            : "inboundBillclientBoxing",
                        params: { type: "query" },
                        query: {
                            id: this.id,
                            warehouseType: this.formData.warehouseType,
                            isManage: this.isManage ? 1 : 0,
                        },
                    }).href,
                    "_blank"
                );
            } else {
                this.$router.push({
                    name: this.isManage
                        ? "inboundBillmanageBoxing"
                        : "inboundBillclientBoxing",
                    query: {
                        id: this.id,
                        warehouseType: this.formData.warehouseType,
                        isManage: this.isManage ? 1 : 0,
                    },
                });
            }
        },
        // 根据仓库获取对应的渠道列表
        getChannel(wareId) {
            HttpFindByOrgIdAndOrgWarehouseId({
                orgId: global.SYSID,
                orgWarehouseId: wareId,
            }).then(
                (res) => {
                    this.channelList = [];
                    this.channelList = res.data;
                },
                (err) => {
                    this.$$VMessage.error(err.message);
                }
            );
        },
        //获取计划单详情
        async getDetail() {
            if (this.isAdd) return;
            if (this.querytype) {
                this.manageuse = this.managetype;
            } else {
                this.manageuse = this.manageuse;
            }
            this.loading = true;

            // 头程物流列表页关联计划单号跳转
            if (!this.id) {
                await HttpGetDetailByNos({ inboundPlanOrderNo: this.no })
                    .then((res) => {
                        this.id = res.data.id;
                        this.handleDetail(res);
                    })
                    .catch((err) => {
                        this.$VMessage.error(err.message);
                    });
            }
            // 正常跳转
            else {
                await HttpInboundBill({ id: this.id })
                    .then((res) => {
                        this.handleDetail(res);
                    })
                    .catch((err) => {
                        this.$VMessage.error(err.message);
                    });
            }
            this.loading = false;
        },
        handleDetail(res) {
            // 传到子组件的时候sku英文名已经转化
            this.chargeSkuEnName(res.data.inboundPlanOrderItemList);
            const data = res.data || {};
            // this.formData = data;
            this.$nextTick(() => {
                this.$refs.formbase.resetValidate();
            });
            this.$set(this, "formData", data);
            this.formData.businessType = data.businessType
                .split("|")
                .map((item) => {
                    if (!item) return;
                    return parseInt(item);
                });
            // 编辑时判断入库仓库显示编辑还是仓库
            if (this.type == "edit") {
                if (this.formData.areaId) {
                    this.inputKey = "areaId";
                    let areaData = this.areaList.filter((item) => {
                        return item.value == this.formData.areaId;
                    })[0];
                    this.modalSelectedData = areaData.label;
                } else {
                    this.inputKey = "orgWarehouseId";
                    this.modalSelectedData = this.formData.orgWarehouseCode;
                }
            }
            this.photoData.orderData = data;
            this.photoData.orderType = 2;
            if (
                this.formData.totalCapacity ||
                this.formData.totalCapacity == 0
            ) {
                this.showCapacity = true;
            }
            if (!this.formData.monthVolume) {
                this.formData.monthVolume = "0.0000";
            }
            if (!this.formData.quarterVolume) {
                this.formData.quarterVolume = "0.0000";
            }
            this.attachList = data.orderAttacheList;
            this.logList = data.orderLogList;
            this.proinblundList = data.inboundPlanOrderPoItemList;
            delete data.inboundPlanOrderItemList;
            delete data.orderAttacheList;
            delete data.orderLogList;

            // 渠道展示
            // console.log(this.formData.orgWarehouseCode)
            if (!this.isQuery) {
                let channelone =
                    this.getFilterDisabledWarehouse.filter((json) => {
                        return (
                            json.attach.code == this.formData.orgWarehouseCode
                        );
                    })[0] || {};
                // 选中区域编辑时没有仓库，防止报错
                if (!channelone.attach) return (this.showOnaccount = false);
                if (channelone.attach.warehouseType == 4) {
                    this.getChannel(channelone.value);
                    this.showOnaccount = true;
                } else this.showOnaccount = false;
            }
            this.formData.cartonNo =
                res.data.gpCartonNo20 ||
                res.data.gpCartonNo40 ||
                res.data.hqCartonNo40 ||
                res.data.hqCartonNo45;
            this.loading = false;
        },
        chargeSkuEnName(skulist) {
            // console.log(skulist,'skulistskulist')
            if (skulist) {
                let skuarr = [];
                skulist.map((item) => {
                    skuarr.push(item.productId);
                });
                HttpGetSKUEnName({
                    productIds: skuarr,
                }).then((res) => {
                    skulist.map((item) => {
                        res.data.map((jsonone) => {
                            if (item.productId === jsonone.id) {
                                item.skuname =
                                    jsonone.nameEn + " (" + jsonone.name + ")";
                            }
                        });
                    });
                    this.productList = skulist;
                    // console.log(skulist,'skuarrskulistskulistskulistskulist')
                });
            }
        },
        //确认发货
        confirmDeliver() {
            HttpIsPackList({
                id: this.id,
            }).then(
                (res) => {
                    this.$emit("on-closeCloseable");
                    this.modalProps = {
                        show: true,
                        title: this.$t("fbb.inbound.confirm_delivery", {
                            defaultValue: "确认发货",
                        }),
                        width: "large",
                        component: "compDelivergood",
                        showFooter: false,
                        isEdit: true,
                        needBox: this.formData.needBox == 1,
                        activeid: this.id,
                        gpNo:
                            this.formData.gpCartonNo20 ||
                            this.formData.gpCartonNo40 ||
                            this.formData.hqCartonNo40 ||
                            this.formData.hqCartonNo45,
                        on: {
                            "on-cancel": () => {
                                this.modalProps = {};
                            },
                            "on-update": this.getDetail,
                            "on-goBoxing": (obj) => this.goBoxing(obj),
                        },
                    };
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        //到仓确认
        confirmAtWarehouse() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.inbound.warehouse_confirm", {
                    defaultValue: "到仓确认",
                }),
                alert: "success",
                showDesc: false,
                width: "middle",
                params: { id: this.id },
                ajaxRequest: HttpConfirmAtWarehouse,
                formdata: [
                    {
                        tag: "vDatepicker",
                        key: "confirmDate",
                        labelWidth: "100",
                        span: 24,
                        label: this.$t("fbb.inbound.date_warehouse", {
                            defaultValue: "到仓日期",
                        }),
                        props: {
                            format: "yy-mm-dd",
                            confirm: false,
                        },
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        labelWidth: "100",
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
            };
        },
        // 到港确认
        confirmAtPost() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.inbound.port_confirm", {
                    defaultValue: "到港确认",
                }),
                alert: "success",
                showDesc: false,
                width: "middle",
                params: { id: this.id },
                ajaxRequest: HttpConfirmAPost,
                formdata: [
                    {
                        tag: "vDatepicker",
                        key: "confirmDate",
                        labelWidth: "100",
                        span: 24,
                        label: this.$t("fbb.inbound.arrival_date", {
                            defaultValue: "到港日期",
                        }),
                        props: {
                            format: "yy-mm-dd",
                            confirm: false,
                        },
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        labelWidth: "100",
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        required: false,
                    },
                ],
            };
        },
        //重推仓库
        pushWareHouse() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.inbound.repush_warehouse", {
                    defaultValue: "重推仓库",
                }),
                alert: "info",
                params: { id: this.id },
                ajaxRequest: HttpPushWareHouse,
            };
        },
        errorReprocess() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("global.common.reprocess", {
                    defaultValue: "重处理",
                }),
                alert: "info",
                params: { id: this.id },
                ajaxRequest: HttpReprocessError,
            };
        },
        ignoreError() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("global.common.ignoreError", {
                    defaultValue: "忽略异常",
                }),
                alert: "info",
                params: { id: this.id },
                ajaxRequest: HttpIgnoreInboundError,
            };
        },
        //完成
        complateBill() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("global.common.finish", {
                    defaultValue: "完成",
                }),
                alert: "success",
                width: "middle",
                showDesc: false,
                params: { id: this.id },
                ajaxRequest: (params) => {
                    params.attachments = JSON.stringify(this.complateFiles);
                    return HttpComplateInboundBill(params);
                },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        labelWidth: 50,
                        span: 24,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                        on: {
                            "on-change": (val) => {
                                this.completeRemark = val;
                            },
                        },
                    },
                    {
                        tag: "vInput",
                        key: "attachments",
                        labelWidth: 50,
                        required: false,
                        default: this.complateFiles.map(
                            (item) => item.fileName
                        ),
                        props: {
                            multiple: true,
                            readonly: true,
                        },
                        on: {
                            "on-remove-item": (val, index) => {
                                this.complateFiles.splice(index, 1);
                                this.updateModal2ByFile();
                            },
                        },
                        span: 24,
                        label: this.$t("global.common.attach_file", {
                            defaultValue: "附件",
                        }),
                    },
                    {
                        tag: "div",
                        span: 24,
                        children: (h) => {
                            return h(
                                "vButton",
                                {
                                    props: { theme: "primary" },
                                    on: {
                                        click: this.uploadComplateFile,
                                    },
                                },
                                this.$t("global.common.add", {
                                    defaultValue: "添加",
                                })
                            );
                        },
                        labelWidth: 50,
                    },
                ],
            };
        },
        updateInboundDate() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.inbound.update_date", {
                    defaultValue: "更新预计入库日期",
                }),
                alert: "info",
                width: "middle",
                showDesc: false,
                params: { id: this.id },
                ajaxRequest: HttpUpdateInboundDate,
                formdata: [
                    {
                        tag: "vDatepicker",
                        key: "inboundDate",
                        labelWidth: 100,
                        default: this.formData.estimateArriveTime,
                        span: 24,
                        label: this.$t("fbb.inbound.exped_warehousedate", {
                            defaultValue: "预计入库日期",
                        }),
                        props: {
                            format: "yy-mm-dd",
                            confirm: false,
                        },
                    },
                    {
                        tag: "vTextarea",
                        key: "remark",
                        labelWidth: 100,
                        span: 24,
                        required: false,
                        label: this.$t("global.common.notes", {
                            defaultValue: "备注",
                        }),
                    },
                ],
            };
        },
        //上传发票
        uploadBill() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.headlogistics.shangchuanfapiao", {
                    defaultValue: "上传发票",
                }),
                alert: "primary",
                width: "middle",
                showDesc: false,
                params: { id: this.id },
                ajaxRequest: (params) => {
                    params.attachments = JSON.stringify(this.billFiles);
                    return HttpUploadBill(params);
                },
                formdata: [
                    {
                        tag: "vInput",
                        key: "billNo",
                        labelWidth: 120,
                        span: 24,
                        label: this.$t("fbb.inbound.supplier_no", {
                            defaultValue: "供应商发票号",
                        }),
                        on: {
                            "on-change": (val) => {
                                this.uploadBillNo = val;
                            },
                        },
                    },
                    {
                        tag: "vDatepicker",
                        key: "billDate",
                        labelWidth: 120,
                        span: 24,
                        label: this.$t("fbb.inbound.supplier_date", {
                            defaultValue: "供应商开票日期",
                        }),
                        props: {
                            format: "yy-mm-dd",
                            confirm: false,
                        },
                        on: {
                            "on-change": (val) => {
                                this.uploadBillDate = val;
                            },
                        },
                    },
                    {
                        tag: "vInput",
                        key: "attachments",
                        labelWidth: 120,
                        default: this.billFiles.map((item) => item.fileName),
                        props: {
                            multiple: true,
                            readonly: true,
                        },
                        on: {
                            "on-remove-item": (val, index) => {
                                this.billFiles.splice(index, 1);
                                this.updateModal3ByFile();
                            },
                        },
                        span: 24,
                        label: this.$t("fbb.inbound.supplier_bill", {
                            defaultValue: "供应商发票",
                        }),
                    },
                    {
                        tag: "div",
                        span: 24,
                        children: (h) => {
                            return h(
                                "vButton",
                                {
                                    props: { theme: "primary" },
                                    on: {
                                        click: this.uploadBillFile,
                                    },
                                },
                                this.$t("global.common.add", {
                                    defaultValue: "添加",
                                })
                            );
                        },
                        labelWidth: 120,
                    },
                ],
            };
        },
        //更新modal2
        updateModal2ByFile() {
            // this.$set(this.modalProps.formdata, 1, { ...this.modalProps.formdata[1], default: this.complateFiles.map(item => item.fileName) })
            this.$set(this.modalProps, "formdata", [
                {
                    ...this.modalProps.formdata[0],
                    default: this.completeRemark,
                },
                {
                    ...this.modalProps.formdata[1],
                    default: this.complateFiles.map((item) => item.fileName),
                },
            ]);
        },
        updateModal3ByFile() {
            this.$set(this.modalProps, "formdata", [
                {
                    ...this.modalProps.formdata[0],
                    default: this.uploadBillNo,
                },
                {
                    ...this.modalProps.formdata[1],
                    default: this.uploadBillDate,
                },
                {
                    ...this.modalProps.formdata[2],
                    default: this.billFiles.map((item) => item.fileName),
                },
            ]);
            //this.$set(this.modalProps.formdata, 2, { ...this.modalProps.formdata[2], default: this.billFiles.map(item => item.fileName) })
        },
        uploadComplateFile() {
            this.$emit("on-closeCloseable");
            this.modalProps2 = {
                show: true,
                title: this.$t("fbb.inbound.upload_attachment", {
                    defaultValue: "上传附件",
                }),
                width: 520,
                showFooter: false,
                component: "compUpload",
                props: {
                    data: {
                        model: "inboundPlanOrder",
                        type: "other",
                        srcLabel: this.id,
                    },
                    ajaxRequest: HttpUploadCompleteFile,
                    name: "multipartFile",
                },
                on: {
                    "on-success": (res) => {
                        const data = res.data.entity;
                        this.complateFiles.push({
                            fileName: data.filename,
                            fileUrl: data.url,
                        });
                        this.updateModal2ByFile();
                        this.modalProps2 = {};
                    },
                    "on-close": () => {
                        this.modalProps2 = {};
                    },
                },
            };
        },
        uploadBillFile() {
            this.$emit("on-closeCloseable");
            this.modalProps2 = {
                show: true,
                title: this.$t("fbb.inbound.upload_attachment", {
                    defaultValue: "上传附件",
                }),
                width: 520,
                showFooter: false,
                component: "compUpload",
                props: {
                    data: {
                        model: "inboundPlanOrder",
                        type: "other",
                        srcLabel: this.id,
                    },
                    ajaxRequest: HttpUploadCompleteFile,
                    name: "multipartFile",
                },
                on: {
                    "on-success": (res) => {
                        const data = res.data.entity;
                        this.billFiles.push({
                            fileName: data.filename,
                            fileUrl: data.url,
                        });
                        this.updateModal3ByFile();
                        this.modalProps2 = {};
                    },
                    "on-close": () => {
                        this.modalProps2 = {};
                    },
                },
            };
        },
        // 获取地址
        // getWarehouseAddress(data) {
        // 	HttpWarehouseAddress(data).then(res => {
        // 		const { address, address2, city, state, country, postal, phone, mobilePhone, linkman, code } = res.data || {};
        // 		this.formData = {
        // 			...this.formData,
        // 			shipperAddress: address,
        // 			shipperPhone: mobilePhone,
        // 			shipperContact: linkman
        // 		}
        // 	}).catch(err => {
        // 		this.clearWarehouseAddress()
        // 	});
        // },
        // clearWarehouseAddress() {
        // 	this.formData = {
        // 		...this.formData,
        // 		shipperAddress: '',
        // 		shipperPhone: '',
        // 		shipperContact: ''
        // 	}
        // },
        // 撤销审核
        // rebackAudit() {
        // 	this.modalProps = {
        // 		show: true,
        // 		title: '撤销审核',
        // 		alert: "error",
        // 		params: { id: this.id },
        // 		ajaxRequest: HttpRevokeAudit,
        // 	}
        // },

        //审核
        async approve() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                width: 600,
                title: this.$t("fbb.inbound.audit", { defaultValue: "审核" }),
                component: "compAudit",
                propsData: this.formData,
                id: this.id,
                showCapacity: this.showCapacity,
                showInboundVolume: this.showInboundVolume,
                showFooter: false,
                on: {
                    "on-update": () => {
                        this.modalProps = {
                            show: false,
                        };
                        this.getDetail();
                    },
                    "on-close": () => {
                        this.modalProps = {
                            show: false,
                        };
                    },
                },
            };
            // this.modalProps = {
            // 	show: true,
            // 	title: this.$t('fbb.inbound.audit', { defaultValue: '审核' }),
            // 	alert: "success",
            // 	showDesc: false,
            // 	width: "middle",
            // 	params: { id: this.id, approve: false, },
            // 	ajaxRequest: HttpCheckInboundBill,
            // 	formdata: [
            // 		{
            // 			tag: "vRadio",
            // 			key: "approve",
            // 			labelWidth: 'auto',
            // 			default: true,
            // 			span: 24,
            // 			label: this.$t('fbb.inbound.audit', { defaultValue: '审核' }),
            // 			options: [{
            // 				trueValue: true,
            // 				label: this.$t('fbb.inbound.pass_audit', { defaultValue: '审核通过' }),
            // 			}, {
            // 				trueValue: false,
            // 				label: this.$t('fbb.inbound.back_audit', { defaultValue: '审核拒回' }),
            // 			}]
            // 		},{
            // 			label: this.$t('fbb.inbound.product_volume', { defaultValue: '产品总体积(CBM)' }),
            // 			labelWidth: 'auto',
            // 			span: 24,
            // 			show:this.showCapacity,
            // 			valueText:this.formData.totalVolume,
            // 			query:true
            // 		},
            // 		{
            // 			label: this.$t('', { defaultValue: '当前客户库容余量/库容总余量/当前客户总库容(CBM)' }),
            // 			labelWidth: 'auto',
            // 			span: 24,
            // 			show:this.showCapacity,
            // 			valueText:this.formData.restCapacity+ '/'+this.formData.totalRestCapacity+ '/'+this.formData.totalCapacity,
            // 			query:true
            // 		},
            // 		{
            // 			label: this.$t('fbb.inbound.month_volume', { defaultValue: '当月入库量(CBM)' }),
            // 			labelWidth: 'auto',
            // 			span: 24,
            // 			show:this.showInboundVolume,
            // 			valueText:this.formData.monthVolume,
            // 			query:true
            // 		},
            // 		{
            // 			label: this.$t('fbb.inbound.quarter_volume', { defaultValue: '当季入库量(CBM)' }),
            // 			labelWidth: 'auto',
            // 			span: 24,
            // 			show:this.showInboundVolume,
            // 			valueText:this.formData.quarterVolume,
            // 			query:true
            // 		},
            // 		{
            // 			tag: "vTextarea",
            // 			key: "remark",
            // 			labelWidth: 'auto',
            // 			span: 24,
            // 			label: this.$t('global.common.notes', { defaultValue: '备注' }),
            // 			required: false
            // 		}
            // 	],
            // }
        },
        //保存
        async save(next) {
            // console.log(this.$refs.productlist)
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true;
            const ajaxRequest = this.isAdd
                ? HttpAddInboundBill
                : HttpUpdateInboundBill;
            let array = [];
            if (this.$refs.productlist.inboundPlanOrderPoItemList.length < 1) {
                array = this.$refs.productlist.proinblundList;
            } else {
                array = this.$refs.productlist.inboundPlanOrderPoItemList;
            }
            return ajaxRequest({
                ...this.formData,
                poNos: this.$refs.productlist.poNos,
                inboundPlanOrderItemModelList: this.$refs.productlist.dataList,
                inboundPlanOrderPoItemModelList: array,
                orderAttachModelList: this.$refs.attachlist.dataList,
            }).then(
                (res) => {
                    if (next === true) {
                        // 没有id
                        return;
                    }
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        //保存提交
        async saveAndSubmit() {
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true;
            let array = [];
            if (this.$refs.productlist.inboundPlanOrderPoItemList.length < 1) {
                array = this.$refs.productlist.proinblundList;
            } else {
                array = this.$refs.productlist.inboundPlanOrderPoItemList;
            }
            return HttpSaveAndSubmitInboundBill({
                ...this.formData,
                poNos: this.$refs.productlist.poNos,
                inboundPlanOrderItemModelList: this.$refs.productlist.dataList,
                inboundPlanOrderPoItemModelList: array,
                orderAttachModelList: this.$refs.attachlist.dataList,
            }).then(
                (res) => {
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },

        //提交审核
        async submit() {
            if (this.isAdd || this.isEdit) {
                const valid = await this.$refs.formbase.validate();
                if (!valid) return;
                if (this.isAdd) {
                    return this.saveAndSubmit();
                }
            }

            this.loading = true;
            let array = [];
            if (this.$refs.productlist.inboundPlanOrderPoItemList.length < 1) {
                array = this.$refs.productlist.proinblundList;
            } else {
                array = this.$refs.productlist.inboundPlanOrderPoItemList;
            }
            return HttpUpdateAndSubmitInboundBill({
                ...this.formData,
                poNos: this.$refs.productlist.poNos,
                inboundPlanOrderItemModelList: this.$refs.productlist.dataList,
                inboundPlanOrderPoItemModelList: array,
                orderAttachModelList: this.$refs.attachlist.dataList,
            }).then(
                (res) => {
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        cancel() {
            if (this.alertbox) {
                this.$emit("on-close");
            } else {
                const name = this.$route.name;
                this.$router.push({
                    name: this.isManage
                        ? "inboundBillmanage"
                        : "inboundBillclient",
                });
            }
        },
        checkCapacity() {
            // console.log(this.formData)
            if (
                this.formData.orgWarehouseId &&
                this.formData.expectArriveDate &&
                global.SYSID == 1
            ) {
                HttpCheckCapacity({
                    contextId: global.SYSID,
                    warehouseId: this.formData.orgWarehouseId,
                    expectDate: this.formData.expectArriveDate,
                }).then((res) => {
                    if (res.data) {
                        this.isCapacity = true;
                        if (res.data.restCapacity == 0) {
                            this.restCapacity = "0.0000";
                        } else {
                            this.restCapacity = res.data.restCapacity;
                        }
                        if (res.data.totalCapacity == 0) {
                            this.totalCapacity = "0.0000";
                        } else {
                            this.totalCapacity = res.data.totalCapacity;
                        }
                    } else {
                        this.isCapacity = false;
                    }
                });
            } else {
                this.isCapacity = false;
            }
        },
        capacity() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                title: this.$t("fbb.inbound.show_capacity", {
                    defaultValue: "查看库容",
                }),
                alert: "success",
                showDesc: false,
                width: "middle",
                single: true,
                formdata: [
                    {
                        label: this.$t("fbb.inbound.total_capacity", {
                            defaultValue: "总库容(CBM)",
                        }),
                        labelWidth: "auto",
                        span: 24,
                        valueText: this.totalCapacity,
                        query: true,
                    },
                    {
                        label: this.$t("fbb.inbound.rest_capacity", {
                            defaultValue: "库容余量(CBM)",
                        }),
                        labelWidth: "auto",
                        span: 24,
                        valueText: this.restCapacity,
                        query: true,
                    },
                ],
            };
        },
    },
};
</script>
